<template>
  <b-nav-item @click.prevent="submit">{{ $t('logout.submit') }}</b-nav-item>
</template>

<script>
export default {
  name: 'LogoutButton',
  methods: {
    async submit () {
      let result
      try {
        result = await this.$api.user.logout()
      } catch (e) { // network error etc.
        result = false
      }

      if (result) {
        this.$store.dispatch('user/saveData', null)
        this.$router.replace('/login')
      } else {
        this.error()
      }

      return result
    },
    error () {
      this.$bvToast.toast(this.$t('logout.error.text'), {
        title: this.$t('logout.error.title'),
        autoHideDelay: 5000,
        appendToast: true,
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-left'
      })
    }
  }
}
</script>

<style scoped>
  a {
    font-weight: bold;
  }

</style>
